import type { MediaSlide } from "@/components/MediaCarousel";

/**
 * Split Before | After picture on /services. Only for photos of the same phone,
 * taken from the same angle; until it's set, the service shows its slideshow.
 */
export type Compare = { before: string; after: string; alt: string };

export const services = [
  {
    id: "screen-polishing",
    title: "Screen Restoration",
    description: "We reduce scratches and restore screen clarity, leaving a cleaner, smoother appearance.",
    // The best grade this service can bring a part to (scale in lib/trust.ts).
    lift: { part: "Screens", from: "C3", to: "A" },
    improves: ["Scratched screens", "Dull or cloudy screens", "Screen clarity and smoothness"],
    compare: undefined as Compare | undefined,
    // Slideshow from the damaged screen to the polished one.
    slides: [
      {
        src: "/videos/work/polish-before-scratched-screen.mp4",
        poster: "/videos/work/polish-before-scratched-screen.jpg",
        alt: "A phone screen covered in scratches, turned under a strip light",
        caption: "Scratched",
      },
      {
        src: "/videos/work/polish-after-polished-screen.mp4",
        poster: "/videos/work/polish-after-polished-screen.jpg",
        alt: "A clear, polished phone screen, turned under a strip light",
        caption: "Polished",
      },
    ] as MediaSlide[],
  },
  {
    id: "frame-refinishing",
    title: "Frame Restoration",
    description: "We restore scratched, chipped, and faded frames, improving their original color and finish.",
    lift: { part: "Bodies", from: "C3", to: "B1" },
    improves: ["Scratched or chipped frames", "Faded or worn-out colors", "Dull or uneven finishes"],
    compare: undefined as Compare | undefined,
    // Slideshow from the worn frame to the restored one.
    slides: [
      {
        src: "/videos/work/paint-before-worn.mp4",
        poster: "/videos/work/paint-before-worn.jpg",
        alt: "A blue iPhone frame with a worn, chipped finish, turned in the hand",
        caption: "Worn",
      },
      {
        src: "/videos/work/paint-after-like-new.mp4",
        poster: "/videos/work/paint-after-like-new.jpg",
        alt: "A blue iPhone frame with a smooth, like-new finish, turned in the hand",
        caption: "Restored",
      },
    ] as MediaSlide[],
  },
] as const;

export type Service = (typeof services)[number];
